import { type FC } from 'react';

import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';

import { useListingContext } from '../../context/ListingContext';

import { NarrowTitle } from './components/NarrowTitle';
import { Title } from './components/Title';

export const TitleContainer: FC = () => {
  const {
    seo: {
      view: { title },
    },
  } = useListingContext();

  const isNarrow = useListingLayoutIsNarrowSelector();

  if (!title) {
    return null;
  }

  return isNarrow ? <NarrowTitle>{title}</NarrowTitle> : <Title>{title}</Title>;
};
